/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AutomaticInputs */

const en_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic`)
};

const es_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const fr_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatique`)
};

const de_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatik`)
};

const ja_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オートマチック (AT)`)
};

const zh_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动挡`)
};

const ar_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوتوماتيك`)
};

const id_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatis`)
};

const it_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatico`)
};

const ru_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая`)
};

const pt_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático`)
};

const ko_val_automatic = /** @type {(inputs: Val_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동`)
};

/**
* | output |
* | --- |
* | "Automatic" |
*
* @param {Val_AutomaticInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_automatic = /** @type {((inputs?: Val_AutomaticInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AutomaticInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_automatic(inputs)
	if (locale === "es") return es_val_automatic(inputs)
	if (locale === "fr") return fr_val_automatic(inputs)
	if (locale === "de") return de_val_automatic(inputs)
	if (locale === "ja") return ja_val_automatic(inputs)
	if (locale === "zh") return zh_val_automatic(inputs)
	if (locale === "ar") return ar_val_automatic(inputs)
	if (locale === "id") return id_val_automatic(inputs)
	if (locale === "it") return it_val_automatic(inputs)
	if (locale === "ru") return ru_val_automatic(inputs)
	if (locale === "pt") return pt_val_automatic(inputs)
	return ko_val_automatic(inputs)
});